export const isPhoneValid = async (phone: string) => {
  try {
    const { PhoneNumberUtil } = await import('google-libphonenumber')
    const phoneUtil = PhoneNumberUtil.getInstance()
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
  } catch (error) {
    return false
  }
}
